module.exports = __webpack_public_path__ + "static/media/goldenboy-fake-keyboard.b3e351b1.gif";